<template>
  <TabPanel>
    <div class="p-formgrid p-grid vertical-container">
      <div class="p-col-12">
        <Panel header="Источники" class="p-mt-3" style="height:400px; width:100%;">
          <ViewCustomData entityName="source" entitySpec="data" serviceName="BaseService" :columns="SOURCE_COLUMNS"
            scrollHeight="400px" @selectedRow="onSelectedRow" :paginator="false" ref="viewSourceData"
            :prepareData="prepareData" :visibleButtons="{ delete: false }" />
        </Panel>
      </div>
    </div>
    <div class="p-col-12">
      <Panel header="Параметры" class="p-mt-3">
        <SourceParamData :sourceId="selected?.source_id > 0 ? selected.source_id : null" />
      </Panel>
    </div>
  </TabPanel>
</template>

<script setup>
import { ref } from 'vue'
import SourceParamData from './SourceParamData.vue'
import { SOURCE_COLUMNS } from './sourceConstants.js'

const selected = ref(null)
const viewSourceData = ref(null)

const onSelectedRow = (value) => {
  selected.value = value
}

const prepareData = (data) => {
  if (data?.length && viewSourceData.value) {
    viewSourceData.value.selected = data[0];
  }
  return data
}
</script>

<style lang="scss" scoped>
:deep(.p-panel .p-panel-header) {
  padding: 0.5rem;
  border: none;
  background: #84abd6 !important;
  flex-direction: column !important;
}

:deep(.p-panel-content) {
  padding: 0.2rem;
}
</style>